import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'portlet',
    template: require('./portlet.component.html')
})
export class PortletComponent {
    @Input() loader: boolean = false;
    constructor() {
	}

	isCollapsed: boolean = false;

	@Input() title;

	@Input() color;

	toggle(): void {
		this.isCollapsed = !this.isCollapsed;
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/portlet.component.ts